import React from 'react';
import NavBar from '../components/NavBar';

const CONTENT = {
  kvkk: {
    title: 'KVKK Metni',
    items: [
      'CihanStock, kullanıcı hesabı oluşturma, bakiye yönetimi, destek talepleri ve hizmet sunumu için gerekli kişisel verileri işler.',
      'İşlenen veriler ad soyad, e-posta, isteğe bağlı telefon, işlem kayıtları, bakiye talepleri ve destek mesajları ile sınırlıdır.',
      'Kişisel veriler hizmetin sağlanması, güvenlik, muhasebe, destek ve yasal yükümlülüklerin yerine getirilmesi amaçlarıyla kullanılır.',
      'Kullanıcılar KVKK kapsamındaki erişim, düzeltme, silme ve itiraz haklarını destek kanalı üzerinden iletebilir.',
    ],
  },
  terms: {
    title: 'Kullanım Şartları ve Koşulları',
    items: [
      'CihanStock hizmetleri yalnızca yasal ve lisans koşullarına uygun kullanım için sunulur.',
      'Kullanıcı, indirdiği içeriklerin kullanım haklarını ve üçüncü taraf platform koşullarını kontrol etmekle yükümlüdür.',
      'Bakiye yüklemeleri dijital hizmet kapsamında değerlendirilir; kötüye kullanım, sahte ödeme bildirimi veya yetkisiz erişim durumunda hesap askıya alınabilir.',
      'CihanStock, teknik bakım, sağlayıcı API kesintisi veya güvenlik gerekçeleriyle hizmette geçici değişiklik yapabilir.',
    ],
  },
  disclosure: {
    title: 'Aydınlatma Metni',
    items: [
      'Veri sorumlusu CihanStock hizmet sahibi olup, kişisel veriler dijital hizmet sunumu amacıyla işlenir.',
      'Veriler MongoDB, e-posta servisleri, ödeme sağlayıcıları ve barındırma altyapısı gibi hizmet sağlayıcılarla sınırlı olarak paylaşılabilir.',
      'E-posta onayı, giriş güvenliği, işlem geçmişi ve destek süreçleri için teknik kayıtlar tutulur.',
      'Kişisel veriler mevzuatta öngörülen süreler ve hizmet ilişkisi devam ettiği müddetçe saklanır.',
    ],
  },
};

export default function LegalPage({ type }) {
  const data = CONTENT[type] || CONTENT.terms;
  return (
    <div className="min-h-screen bg-background text-foreground">
      <NavBar />
      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="glass-card rounded-3xl p-8">
          <p className="text-xs uppercase tracking-[0.3em] text-fuchsia-300 mb-3">CihanStock Legal</p>
          <h1 className="text-3xl font-bold mb-6">{data.title}</h1>
          <div className="space-y-4 text-muted-foreground leading-7">
            {data.items.map((item, index) => (
              <div key={index} className="p-4 rounded-2xl bg-white/5 border border-white/10">
                <strong className="text-white mr-2">{index + 1}.</strong>{item}
              </div>
            ))}
          </div>
          <p className="text-xs text-muted-foreground mt-8">Son güncelleme: {new Date().toLocaleDateString('tr-TR')}</p>
        </div>
      </main>
    </div>
  );
}
